import React, { useEffect, useRef, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Box from "@mui/material/Box";
import SwipeableDrawer from "@mui/material/SwipeableDrawer";
import Grid from "@material-ui/core/Grid";
import { format } from "date-fns";
import FilterAltIcon from "@mui/icons-material/FilterAlt";
import RestartAltIcon from "@mui/icons-material/RestartAlt";
import DynamicForm from "f1-dynamic-form-react";
import CloseIcon from "@mui/icons-material/Close";
import Paper from "@material-ui/core/Paper";
import Typography from "@material-ui/core/Typography";
import { ApiUrls } from "../api/baseURL";
import { FILTER_FORM_STORAGE } from "./formData";
import { post } from "../api/api";
import Loader from "../components/loader/loader";
import useOnlineStatus from "../useOnlineStatus";
import { metaDataConstants } from "../utils/Constants/constants-en";
import { getDateWithFormat } from "../utils/utils";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  drawerMobile: {
    display: "none",
    [theme.breakpoints.down("xs")]: {
      display: "block",
    },
    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
  },
  desktopFilter: {
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
}));

function StorageCountSummary(props) {
  const classes = useStyles();
  const [state, setState] = useState({ top: false });
  const toggleDrawer = (anchor, open) => (event) => {
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }
    setState({ ...state, [anchor]: open });
  };

  const [totalStorageCount, setTotalStorageCount] = useState([]);
  const isOnline = useOnlineStatus();
  const [showOfflineText, setShowOfflineText] = useState(true)
  useEffect(() => {
    if (isOnline) {
      setShowOfflineText(false)
      getAccount();
    }
  }, [isOnline])

  const resetFilters = (anchor) => {
    setActivateLoader(true);
    const copyFormData = [...candidateDetail];
    copyFormData[1].options = [];
    setCandidateDetail(copyFormData);
    setCurrent({
      account: "null",
      location: "",
    });
    setTotalStorageCount([]);
    setLabelData({
      accountName: null,
      locationName: null,
      storageName: null
    })
    setActivateLoader(false);
  };

  const [activateLoader, setActivateLoader] = useState(false);
  const [candidateDetail, setCandidateDetail] = useState(FILTER_FORM_STORAGE);
  const [show, setShow] = useState(false);
  const [serverityStatus, setServerityStatus] = useState("");
  const [message, setMessage] = useState("");
  const [breadcrumbs, setBreadcrumbs] = useState([]);
  const dateFormate = "MM-dd-yyyy HH:mm:ss";
  const [createdDate, setCreatedDate] = useState(
    getDateWithFormat(dateFormate)
  );
  const [LocationData, setLocationData] = useState([]);
  const [accountData, setAccountData] = useState([]);
  const [storageData, setStorageData] = useState([]);
  const [startDate, setStarDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [current, setCurrent] = useState({
    account: "null",
    location: null,
    storageArea: null,
  });

  const [text, setText] = useState("");
  const [frequency, setFrequency] = useState(null);
  const [labelData, setLabelData] = useState({
    accountName: null,
    storageName: null,
    locationName: null,
  });
  const [inventoryCheckId, setInventoryCheckId] = useState(null);
  const [locationStorageId, setLocationStorageId] = useState(null);
  const [accounId, setAccountId] = useState(0);
  const getDropdownData = (optionsArr, key, label) => {
    const arr = optionsArr?.map((item) => {
      return {
        key: item[key],
        label: item[label]?.charAt(0)?.toUpperCase() + item[label]?.slice(1),
        value: item[key],
      };
    });
    arr.unshift({ key: "select", label: "Select", value: "" });
    return arr;
  };

  useEffect(() => {
    candidateDetail[1].options = [];
    const dateFormate = "yyyy-MM-dd";
    setCreatedDate(getDateWithFormat(dateFormate));
  }, []);

  const getAccount = async () => {
    const payload = {
      UserId: localStorage.getItem("userID"),
      IsActive: 1,
    };
    setActivateLoader(true);
    const response = await post(ApiUrls().ACCOUNT_BY_CURRENT_USER, payload).catch(
      function (error) {
        // Handle errors here
        setActivateLoader(false);
        console.error("Error:", error);
      }
    );

    if (response?.status === 200) {
      const data = response?.data.result;
      setAccountData(response?.data.result);
      const copyFormData = [...candidateDetail];
      copyFormData[0].options = getDropdownData(data, "id", "accountName");
      setCandidateDetail(copyFormData);
      getFiscalYear();
    } else {
      setActivateLoader(false);
    }
  };

  const getFiscalYear = async () => {
    const currentYear = new Date().getFullYear();
    const payload = {
      fiscalYear: currentYear + 1,
      isMonthFlag: 2,
    };
    const response = await post(ApiUrls().GET_FISCAL_WEEK, payload).catch(function (
      error
    ) {
      // Handle errors here
      console.error("Error:", error);
    });

    if (response?.status === 200) {
      setActivateLoader(false);
      const currentDate = new Date();
      const data = response?.data.result.filter(
        (ele) =>
          currentDate > new Date(ele.startDate) &&
          currentDate < new Date(ele.endDate)
      );
      const dateFormate = "MM/dd/yyyy";
      const Start = data[0]?.startDate;
      const End = data[0]?.endDate;
      if (Start != undefined && End != undefined) {
        const Range = `${format(new Date(Start), dateFormate)} - ${format(
          new Date(End),
          dateFormate
        )}`;
        setStarDate(Range);
      }
    } else {
      setActivateLoader(false);
    }
  };

  const getLocation = async (feq, accountId) => {
    let payload;
    let currentMonth = new Date().getMonth();
    let currentYear = new Date().getFullYear();
    if (feq === "Monthly") {
      payload = {
        IsActive: 1,
        month: currentMonth + 1,
        year: currentYear,
        accountId: accountId,
        workflowModuleKey: "INVENTORY_COUNT_FILL",
        moduleKey: 1,
        masterId: accountId,
        timeOffset: -330,
        DateRange: null,
        take: 1000,
        skip: 0,
        page: 1,
        pageSize: 1000,
      };

      setActivateLoader(true);

      const response = await post(ApiUrls().GET_LOCATION, payload).catch(function (
        error
      ) {
        // Handle errors here
        setActivateLoader(false);
        console.error("Error:", error);
      });
      if (response?.status === 200) {
        setActivateLoader(false);
        setLocationData(response?.data.result);
        const data = response?.data.result;
        const copyFormData = [...candidateDetail];
        copyFormData[1].options = getDropdownData(
          data,
          "locationId",
          "locationName"
        );
        setCandidateDetail(copyFormData);
      } else {
        setActivateLoader(false);
      }
    } else {
      payload = {
        IsActive: 1,
        month: currentMonth + 1,
        year: currentYear,
        accountId: accountId,
        workflowModuleKey: "INVENTORY_COUNT_FILL",
        moduleKey: 1,
        masterId: accountId,
        timeOffset: -330,
        DateRange: startDate,
        take: 1000,
        skip: 0,
        page: 1,
        pageSize: 1000,
      };
      setActivateLoader(true);
      const response = await post(ApiUrls().GET_LOCATION, payload).catch(function (
        error
      ) {
        // Handle errors here
        setActivateLoader(false);
        console.error("Error:", error);
      });

      if (response?.status === 200) {
        setActivateLoader(false);
        setLocationData(response?.data.result);
        const data = response?.data.result;
        const copyFormData = [...candidateDetail];
        copyFormData[1].options = getDropdownData(
          data,
          "locationId",
          "locationName"
        );
        setCandidateDetail(copyFormData);
      } else {
        setActivateLoader(false);
      }
    }
  };

  const onSubmitHandler = async (model, anchor) => {
    if (
      (!model.isValidForm && Object.keys(model.errors).length > 0) ||
      Object.keys(model.errors).length > 0
    ) {
      return false;
    }
    setActivateLoader(true);
    if (anchor) {
      setState({ ...state, [anchor]: false });
    }
    const accData = accountData?.filter((el) => el.id == model.account);
    const res = storageData?.filter(
      (ele) => ele.storageCode == model.storageArea
    );
    const filtDataLocation = candidateDetail[1].options.find(
      (item) => item.key == model.location
    );
    setLabelData({
      ...labelData,
      accountName: accData[0]?.accountName,
      locationName: filtDataLocation.label,
      storageName: current.inventoryduedate,
    });
    setLocationStorageId(res[0]?.locationStorageId);
    const payload = {
      AccountId: model.account,
      LocationId: model.location,
      IsActive: 1,
      dueDate: current.inventoryduedate,
      take: 1000,
      skip: 0,
      Page: 1,
      PageSize: 1000,
    };
    const response = await post(ApiUrls().GET_INVENTORY_STORAGE, payload).catch(function (error) {
      // Handle errors here
      setActivateLoader(false);
      console.error("Error:", error);
    });
    if (response?.status === 200) {
      setActivateLoader(false);
      setTotalStorageCount(response?.data.result);
    } else {
      setActivateLoader(false);
    }
  };

  const onFilterChange = async (event, key, model) => {
    if (key === "account") {
      const accountId = event.target.value;
      setCurrent({
        ...current,
        account: accountId,
        location: "",
      });
      setAccountId(accountId);
      const res = accountData?.filter((ele) => ele.id == accountId);
      const feq = res[0].inventoryFrequencyMetadataName;
      setFrequency(res[0].inventoryFrequencyMetadataName);
      const copyFormData = [...candidateDetail];
      setCandidateDetail(copyFormData);
      getLocation(feq, accountId);
    }
    if (key === "location") {
      const locationId = event.target.value;
      const res = LocationData?.filter((ele) => ele.locationId == locationId);
      setCurrent({
        ...current,
        location: locationId,
        inventoryduedate: res[0]?.dueDate?.slice(0, 10),
      });
      setInventoryCheckId(res[0]?.id);
    }
  };
  return (
    <div className="container containerMainDiv">
      <div className="contentdivBg pt-0">
        <div className="divRound pt-3">
          {showOfflineText ? <p style={{ marginTop: "11%", color: "red" }}>{metaDataConstants.youAreOffline}</p>
            : null}
          <h3 className="form-title">{metaDataConstants.storageCountSummary}</h3>
          <div className="activityList" style={{ margin: "0" }}>
            <div className="tabBox"></div>
            <Grid className="activiPad0" container columns={{ xs: 4, md: 12 }}>
              <Grid item xs={12} md={9} className="leftCol">
                <Grid spacing={3} container textalign="left" className="mr-3">
                  <Grid item xs={12} md={4} className="pb-0 mb-0">
                    <span style={{ fontWeight: "bold" }}>{metaDataConstants.invDueDate}</span>
                    <div className="productListDiv2 disbledinput">
                      {" "}
                      <span>
                        {labelData.storageName ? labelData.storageName : null}
                      </span>
                    </div>
                  </Grid>
                  <Grid item xs={12} md={4} className="pb-0 mb-0">
                    <span style={{ fontWeight: "bold" }}>{metaDataConstants.accountLabel}</span>
                    <div className="productListDiv2 disbledinput">
                      {" "}
                      <span>
                        {labelData.accountName ? labelData.accountName : null}
                      </span>
                    </div>
                  </Grid>
                  <Grid item xs={12} md={4} className="pb-0 mb-0">
                    <span style={{ fontWeight: "bold" }}>{metaDataConstants.locationLabel}</span>
                    <div className="productListDiv2 disbledinput">
                      {" "}
                      <span>
                        {labelData.locationName ? labelData.locationName : null}
                      </span>
                    </div>
                  </Grid>
                </Grid>
                <Grid
                  container
                  spacing={3}
                  textalign="left"
                  className="p-2 mt-2 productListDiv"
                >
                  {totalStorageCount?.slice(0, 10).map((item, index) => {
                    const keys = Object.keys(item);
                    return (
                      <Grid item xs={12} md={4}>
                        <Grid
                          container
                          alignItems="center"
                          spacing={3}
                          style={{ position: "relative" }}
                          className="cardBoxAcivity"
                        >
                          <Paper className={classes.paper}>
                            <Grid item xs={12}>
                              <Grid container spacing={3} className="cardTop">
                                <Grid item xs={12}>
                                  <Typography
                                    variant="h5"
                                    component="h2"
                                    className={classes.heading}
                                  >
                                    <b className="mobHeader">{metaDataConstants.storageAreaLabel}</b>
                                    <span className="branchName">
                                      {item.storageName}
                                    </span>
                                  </Typography>
                                </Grid>
                                <Grid item xs={12} md={5} className="buttonBox">
                                </Grid>
                              </Grid>
                              <Grid container className="labelGroup">
                                <Grid
                                  item
                                  xs={6}
                                  className={classes.subHeading}
                                >
                                  <label>{metaDataConstants.counted}</label>
                                </Grid>
                                <Grid item xs={6}>
                                  <span className="subHeadBlue">
                                    <span className={classes.subHeadingBold}>
                                      {item.counted}
                                    </span>
                                  </span>
                                </Grid>
                                <Grid
                                  item
                                  xs={6}
                                  className={classes.subHeading}
                                >
                                  <label>{metaDataConstants.notCounted}</label>
                                </Grid>
                                <Grid item xs={6}>
                                  <span className="subHeadBlue">
                                    <span className={classes.subHeadingBold}>
                                      {item.notCounted}
                                    </span>
                                  </span>
                                </Grid>
                                <Grid
                                  item
                                  xs={6}
                                  className={classes.subHeading}
                                >
                                  <label>{metaDataConstants.total}</label>
                                </Grid>
                                <Grid item xs={6}>
                                  <span className="subHeadBlue">
                                    <span className={classes.subHeadingBold}>
                                      {item.notCounted + item.counted}
                                    </span>
                                  </span>
                                </Grid>
                                <Grid
                                  item
                                  xs={6}
                                  className={classes.subHeading}
                                >
                                  <label>{metaDataConstants.status}</label>
                                </Grid>
                                <Grid item xs={6}>
                                  <span className="subHeadBlue">
                                    <span className={classes.subHeadingBold}>
                                      {item.status == 3 ? <div> <span className="icnComplete"></span>{metaDataConstants.completed}</div> : item.status == 2 ? <div> <span className="icnInProgress"></span>{metaDataConstants.inProgress}</div> : <div> <span className="icnNotStart"></span>{metaDataConstants.notStarted}</div>}

                                    </span>
                                  </span>
                                </Grid>
                              </Grid>
                            </Grid>
                          </Paper>
                        </Grid>
                      </Grid>
                    );
                  })}
                </Grid>
              </Grid>
              <Grid item xs={12} md={3} className="rightCol">
                <div className={classes.desktopFilter}>
                  <div className="filterBox ml-3">
                    <h4 className="filterSec">
                      {" "}
                      <FilterAltIcon className="icnFilter" /> {metaDataConstants.filterBy}
                    </h4>
                    <DynamicForm
                      key={"filterId"}
                      title={" "}
                      buttonSubmit={metaDataConstants.applyFilter}
                      defaultValues={current}
                      model={FILTER_FORM_STORAGE}
                      onSubmit={(model) => {
                        onSubmitHandler(model);
                      }}
                      disableSubmitOnInValid={false}
                      design="bootrstap" // material/bootrstap/advanceMaterial/advanceBootstrap
                      materialOutline={false}
                      onChange={(event, key) => onFilterChange(event, key)}
                      showAstersikOnRequiredFields={true}
                      className="activityFilters"
                      extaraActionFormButton={
                        <span className="reset" onClick={resetFilters}>
                          <RestartAltIcon /> {metaDataConstants.reset}
                        </span>
                      }
                    />
                  </div>
                </div>
                <span className={classes.drawerMobile}>
                  {["top"].map((anchor) => (
                    <React.Fragment key={anchor}>
                      <Box
                        className="editBtn"
                        sx={{ "& > :not(style)": { m: 1 } }}
                        onClick={toggleDrawer(anchor, true)}
                      >
                        <span className="icnFilterBox">
                          {" "}
                          {metaDataConstants.filterBy}
                          <FilterAltIcon />{" "}
                        </span>
                      </Box>
                      <SwipeableDrawer
                        anchor={anchor}
                        open={state[anchor]}
                        onClose={toggleDrawer(anchor, false)}
                        onOpen={toggleDrawer(anchor, true)}
                      >
                        <div className="filterBox">
                          <h4 className="filterSec">
                            <FilterAltIcon className="icnFilter" /> {metaDataConstants.filterBy}{" "}
                            <span
                              style={{ float: "right" }}
                              onClick={toggleDrawer(anchor, false)}
                            >
                              <CloseIcon />
                            </span>
                          </h4>
                          <DynamicForm
                            key={"filterId"}
                            title={" "}
                            buttonSubmit={metaDataConstants.applyFilter}
                            defaultValues={current}
                            model={FILTER_FORM_STORAGE}
                            onSubmit={(model) => {
                              onSubmitHandler(model, anchor);
                            }}
                            disableSubmitOnInValid={false}
                            design="bootrstap" // material/bootrstap/advanceMaterial/advanceBootstrap
                            materialOutline={false}
                            onChange={(event, key) =>
                              onFilterChange(event, key)
                            }
                            showAstersikOnRequiredFields={true}
                            className="activityFilters activityFiltersMobile"
                            extaraActionFormButton={
                              <span
                                className="reset"
                                onClick={() => resetFilters(anchor)}
                                style={{ marginRight: 15 }}
                              >
                                <RestartAltIcon /> {metaDataConstants.reset}
                              </span>
                            }
                          />
                          <Loader active={activateLoader} />
                        </div>
                      </SwipeableDrawer>
                    </React.Fragment>
                  ))}
                </span>
              </Grid>
            </Grid>
            <div>
              <Loader active={activateLoader} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default StorageCountSummary;
